// extracted by mini-css-extract-plugin
export default {"messagesWrapper":"MessagesList_messagesWrapper__iz3HT"};